import React from 'react';
import {useStore} from "@/app/providers/StoreProvider";
import {handleInvite} from "@/shared/utils/referralLink";
import ImgPlus from "@/shared/pictures/plus.svg";
import ImgFriends from "@/shared/pictures/friends.png";
import {observer} from "mobx-react-lite";

export const ProfileFriendWidget = observer(() => {
    const {userStore} = useStore();
    const { friends, referralLink } = userStore;
    return (
        <div className='friends'>
            <div>
                <h3 className='friends_title'>Друзья</h3>
                <p className='friends_count'>{friends}</p>
            </div>
            <div>
                <button type='button' className='friends_invite' onClick={()=>handleInvite(referralLink, 'Мне нужна твоя помощь, участвую в рейтинге приложения Александра Овечкина. Чем выше рейтинг, тем выше шанс получать подарки. Присоединяйся тоже, давай соревноваться вместе.')}>Пригласить <img src={ImgPlus} alt="plus" /></button>
                <img className='friends_img' src={ImgFriends} alt="friends" />
            </div>
        </div>
    );
});

